import { EMPTY_OBJECT } from '../../../constants/common'
import { PROVIDER_USER_ROLE } from '../../../constants/user'
import { getUserAvatar } from '../../../utils/user'
import { getUserLabel } from '../../User'
import {
  getRequestEditUserModalInitialValue,
  getRequestEditUserModalPayload,
} from '../RequestEditUserModal'

import {
  REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS,
  REQUEST_EDIT_PROVIDER_MODAL_PAYLOAD_FIELD_NAME,
} from './RequestEditProviderModal.constants'

function toProviderSelectItem(user) {
  return {
    additionalData: user.email,
    avatar: getUserAvatar(user),
    fullname: user.name,
    label: getUserLabel({ fullname: user.name, role: PROVIDER_USER_ROLE }),
    role: PROVIDER_USER_ROLE,
    value: user.id,
  }
}

export function getRequestEditProviderModalInitialValues({
  itemAction,
  users,
} = EMPTY_OBJECT) {
  return getRequestEditUserModalInitialValue({
    itemAction,
    userFieldName: REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS,
    users,
  })
}

export function getRequestEditProviderModalPayload(values) {
  return getRequestEditUserModalPayload({
    payloadParamKey: REQUEST_EDIT_PROVIDER_MODAL_PAYLOAD_FIELD_NAME,
    userFieldName: REQUEST_EDIT_PROVIDER_MODAL_FIELD_NAME_PROVIDERS,
    values,
  })
}

export function toSelectListItems(items) {
  return items.map(toProviderSelectItem)
}
